// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3rmlo","legacyBtn":"MutateMid_legacyBtn__V_wvY"};